import RadioButton from '../common/radio-button.tsx';
import { ElementType } from '../../utils/enums.ts';

type IProps = {
  value: ElementType;
  onChange: (type: ElementType) => void;
};

export const TypeSelect = ({ value, onChange }: IProps) => {
  return (
    <div className={'grid grid-cols-2 gap-2'}>
      <RadioButton
        name={'type'}
        value={ElementType.QUIZ}
        checked={value === ElementType.QUIZ}
        label={'Quizzes'}
        className="h-10 px-3 text-sm"
        onChange={() => onChange(ElementType.QUIZ)}
      />
      <RadioButton
        name={'type'}
        value={ElementType.TEST}
        checked={value === ElementType.TEST}
        label={'Tests'}
        className="h-10 px-3 text-sm"
        onChange={() => onChange(ElementType.TEST)}
      />
    </div>
  );
};
